<template>
  <div class="box">
    <!-- 标题和搜索盒子 -->
    <div class="headlogo">
      <!-- 左侧盒子 -->
      <div class="head-left">
        <!-- logo -->
          <div class="msoimg">
            <img src="../assets/imgs/clurlogo.png" alt="">
          </div>
          <!-- logo标题 -->
          <div class="mso-title">
            <div class="text1">
              江苏海宏智能科技有限公司
            </div>
            <div class="text2">
              -JIANGSU OCEAN&MACRO INTELLIGENT TECHNOLOGY Co., Ltd.-
            </div>
          </div>
      </div>
      <!-- 右侧盒子 -->
      <div class="head-rgiht">
        <!-- 微信公众号 -->
        <div class="weChat-official-account">
          <img src="../assets/imgs/微信.png" alt="">
          <el-button type="text" class="but-left">微信公众号</el-button>
          <p class="horizontal-line"></p>
          <el-button type="text" class="but-right">收藏本站</el-button>
          <!-- 二维码 -->
          <div class="QR-code">
            <img src="../assets/imgs/公众号 拷贝.png" alt="">
          </div>
        </div>
        <!-- 右侧搜索输入框和按钮 -->
        <div class="head-inp">
          <el-input type="text" placeholder="输入关键词搜索" v-model="search"></el-input>
          <el-button class="head-but" @click="searchbtn">搜索</el-button>
        </div>
      </div>
    </div>
    <!-- 导航栏盒子 -->
    <el-breadcrumb class="Navigation">
        <el-breadcrumb-item class="a-link" :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item class="a-link" :to="{ path: './AboutUs' }"><a>关于我们</a></el-breadcrumb-item>
        <el-breadcrumb-item class="a-link" :to="{ path: '/ProductCenter' }"><a>产品中心</a></el-breadcrumb-item>
        <el-breadcrumb-item class="a-link" :to="{ path: '/CaseSharing' }"><a>案例分享</a></el-breadcrumb-item>
        <el-breadcrumb-item class="a-link" :to="{ path: '/TalentRecruitment' }"><a>人才招聘</a></el-breadcrumb-item>
        <el-breadcrumb-item class="a-link" :to="{ path: '/Businesscooperation' }"><a>商务合作</a></el-breadcrumb-item>
        <el-breadcrumb-item class="a-link" :to="{ path: '/Notice' }"><a>公告</a></el-breadcrumb-item>
        <!-- <el-breadcrumb-item class="a-link" :to="{ path: '/Bidding' }"><a>招投标公告栏</a></el-breadcrumb-item> -->
        <el-breadcrumb-item></el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 您的位置 -->
    <div class="location">
      <!-- 上半部分标题 -->
      <div class="location-top">
        <p>您的位置:</p>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>关于我们</el-breadcrumb-item>
          <el-breadcrumb-item>{{this.activeName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 下半部分tabs标签页 -->
      <div class="location-bottom">
        <a href="#" class="notice-link" @click="biddingBtn(0)">11.10招标公告-连云港石梁河水库采砂信息化监管平台升级改造项目</a>
        <a href="#" class="notice-link" @click="biddingBtn(1)">11.25中标公告-连云港石梁河水库采砂信息化监管平台升级改造项目</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // 招投标公告栏
  name: 'Bidding',
  data() {
    return {
      search: '',
      activeName: '招投标公告栏'
    }
  },
  methods: {
    searchbtn() {
      console.log(this.search)
    },
    biddingBtn(index) {
      if (index === 0) {
        // 跳转到11.10招标公告详情页（匹配路由配置的path）
        this.$router.push('/biddingAnnouncement01')
      } else {
        // 后续扩展：跳转到11.25中标公告详情页
        this.$router.push('/biddingAnnouncement02')
      }
    }
  },
  components: {

  }
}
</script>

<style scoped>
.location {
  width: 100%;
  height: 100%;
  margin-top: 3.9375rem;
}

.location-top {
  width: 100%;
  height: 100%;
  display: flex;
  padding-bottom: 3.75rem;
  line-height: 1.5625rem;
  font-size: 1.625rem;
}

.location-top .el-breadcrumb,
/deep/ .location .el-breadcrumb__inner,
/deep/ .el-breadcrumb__separator {
  font-size: 1.625rem;
  color: #000;
}

/deep/ .location-top .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #000 !important;
}

.location-top p {
  width: 112px;
  margin-right: .625rem;
  padding-left: 8.125rem;
}

.location-bottom {
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* 改为顶部对齐更符合阅读习惯 */
  padding: 0 8.125rem;
  width: 100%; /* 替换固定120rem，适配不同屏幕 */
  max-width: 120rem; /* 保留最大宽度，防止过宽 */
  height: 100%;
  box-sizing: border-box; /* 防止padding撑大宽度 */
}

/* 公告链接样式优化 */
.notice-link {
  font-size: 1.75rem; /* 适配页面字体大小 */
  color: #409EFF; /* 主题蓝色，和页面风格统一 */
  line-height: 2.5; /* 舒适的行高 */
  padding: 0.75rem 0; /* 上下内边距，增加点击区域 */
  text-decoration: none; /* 去掉默认下划线 */
  border-bottom: 1px solid #f0f5ff; /* 浅蓝底边框，增加层次感 */
  transition: all 0.3s ease; /* 过渡动画，更丝滑 */
  display: block; /* 块级显示，点击区域更宽 */
}

/* 鼠标悬浮效果 */
.notice-link:hover {
  color: #1989fa; /* 加深蓝色 */
  text-decoration: underline; /* 悬浮显示下划线 */
  background-color: #f8fbff; /* 轻微背景色，提升交互感 */
  padding-left: 0.5rem; /* 轻微左移，增加动效 */
}

/* 第一个链接增加上外边距，第二个增加下间距 */
.notice-link:first-child {
  margin-top: 0.5rem;
}

.notice-link:last-child {
  margin-bottom: 1rem;
}

/deep/ .el-tabs__nav-scroll {
  width: 100%;
  height: 3.75rem;
  padding-left: 8.125rem;
}

/deep/ .el-tabs__nav-wrap::after {
  position: absolute;
  left: 8.125rem;
}

/deep/ .location-bottom .el-tabs__item {
  font-size: 1.875rem;
  padding-right: 6.875rem;
}

/deep/ .el-tabs__active-bar {
  position: absolute;
  bottom: -1.25rem;
  border-bottom: .3125rem solid #409EFF;
}

/deep/.location-top .el-breadcrumb__inner.is-link {
  font-weight: 400 !important;
}

/deep/.location-top .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  color: #000;
}
</style>
